import ConfigService from './Config';
import BaseService from './Base';

class PropertyService extends BaseService {
  static endpoint = 'api/2.0/properties/';

  static async getMetrics(property, filters, skipLoading) {
    const url = ConfigService.generateURL(this.endpoint+property+'/mrb-metrics/', filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }

    const response = await window.fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': 'jwt ' + localStorage.getItem('jwt_token'),
        'Time-Zone': jstz.determine().name()
      }
    });
    try {
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    }
    catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  }
}

export default PropertyService;